var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.seasons.data),function(season){return _c('season-vertical-component',{key:season.id,attrs:{"season":season}})}),1),_c('div',{staticClass:"row text-center"},[_c('paginate-component',_vm._b({},'paginate-component',_vm.seasons,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }